<template>
    <!-- 查看附件弹窗 -->
    <a-modal
      width="50%"
      :visible="enclosureVisible"
      title="合同附件"
      :maskClosable="false"
      @cancel="enclosureVisible = false"
      :footer="null"
    >
      <div class="achievementPopup-box">
        <div v-for="(item, index) in contractsDetails.contractUrlList" :key="index">
          <div class="box" v-if="item.fileSuffix === '.pdf'" >
            <img style="width: 100px; height: 120px" src="../../../../../assets/icons/pdf.svg" alt="" />
          </div>
          <div class="box" v-else-if="item.fileSuffix === '.xlsx'" >
            <img style="width: 100px; height: 100px; margin-top: 10px" src="../../../../../assets/icons/els.svg" alt="" />
          </div>
          <img style="width: 100px; height: 120px" @click="priviewFile(item)" v-else :src="OSS_BASE_URL + item.fileName" alt="" />
          <div>
            <p>租赁合同</p>
            <a @click="downloadImg(item.url)"> 下载 </a>
          </div>
        </div>
        <div v-for="item in contractsDetails.lessorCardUrlList" :key="item.ossId">
          <div class="box" v-if="item.fileSuffix === '.pdf'" >
            <img style="width: 100px; height: 120px" src="../../../../../assets/icons/pdf.svg" alt="" />
          </div>
          <div class="box" v-else-if="item.fileSuffix === '.xlsx'" >
            <img style="width: 100px; height: 100px; margin-top: 10px" src="../../../../../assets/icons/els.svg" alt="" />
          </div>
          <img style="width: 100px; height: 120px" @click="priviewFile(item)" v-else :src="OSS_BASE_URL + item.fileName" alt="" />
          <div>
            <p>业主身份证</p>
            <a @click="downloadImg(item.url)"> 下载 </a>
          </div>
        </div>
        <div v-for="item in contractsDetails.lesseeCardUrlList" :key="item.ossId">
          <div class="box" v-if="item.fileSuffix === '.pdf'" >
            <img style="width: 100px; height: 120px" src="../../../../../assets/icons/pdf.svg" alt="" />
          </div>
          <div class="box" v-else-if="item.fileSuffix === '.xlsx'" >
            <img style="width: 100px; height: 100px; margin-top: 10px" src="../../../../../assets/icons/els.svg" alt="" />
          </div>
          <img style="width: 100px; height: 120px" @click="priviewFile(item)" v-else :src="OSS_BASE_URL + item.fileName" alt="" />
          <div>
            <p>租客身份证</p>
            <a @click="downloadImg(item.url)"> 下载 </a>
          </div>
        </div>
        <div v-for="item in contractsDetails.propertyUrlList" :key="item.ossId">
          <div class="box" v-if="item.fileSuffix === '.pdf'" >
            <img style="width: 100px; height: 120px" src="../../../../../assets/icons/pdf.svg" alt="" />
          </div>
          <div class="box" v-else-if="item.fileSuffix === '.xlsx'" >
            <img style="width: 100px; height: 100px; margin-top: 10px" src="../../../../../assets/icons/els.svg" alt="" />
          </div>
          <img style="width: 100px; height: 120px" @click="priviewFile(item)" v-else :src="OSS_BASE_URL + item.fileName" alt="" />
          <div>
            <p>产权证</p>
            <a @click="downloadImg(item.url)"> 下载 </a>
          </div>
        </div>
        <div v-for="item in contractsDetails.otherUrlList" :key="item.ossId">
          <div class="box" v-if="item.fileSuffix === '.pdf'" >
            <img style="width: 100px; height: 120px" src="../../../../../assets/icons/pdf.svg" alt="" />
          </div>
          <div class="box" v-else-if="item.fileSuffix === '.xlsx'" >
            <img style="width: 100px; height: 100px; margin-top: 10px" src="../../../../../assets/icons/els.svg" alt="" />
          </div>
          <img style="width: 100px; height: 120px" @click="priviewFile(item)" v-else :src="OSS_BASE_URL + item.fileName" alt="" />
          <div>
            <p>其他文件</p>
            <a @click="downloadImg(item.url)"> 下载 </a>
          </div>
        </div>
      </div>
    </a-modal>
</template>

<script>
const OSS_BASE_URL = process.env.VUE_APP_OSS_URL
export default {
    props: {
        contractsDetails: {
            type: Object,
            default: () => ({})
        }
    },
    watch: {
        contractsDetails: {
            handler () { },
            deep: true,
            immediate: true
        }
    },
    data () {
        return {
            OSS_BASE_URL,
            enclosureVisible: false
        }
    },
    methods: {
        // 下载图片
        downloadImg (url) {
            // var img = document.getElementById(name); // 获取要下载的图片
            // var url = img.src;                            // 获取图片地址
            var a = document.createElement('a') // 创建一个a节点插入的document
            var event = new MouseEvent('click') // 模拟鼠标click点击事件
            a.download = 'beautifulGirl' // 设置a节点的download属性值
            a.href = url // 将图片的src赋值给a节点的href
            a.dispatchEvent(event)
        }, 
        // 预览
        priviewFile(item){
          this.$emit('priviewFile',item)
        }                     
    }
}
</script>

<style lang="less" scoped>
// 弹窗
.achievementPopup-box {
  display: flex;

  flex-wrap: wrap; /*换行*/
  padding-bottom: 160px;
  > div {
    margin-right: 40px;
    div {
      display: flex;
      padding: 16px 0;
      justify-content: space-between;
      p {
        font-weight: 700;
        font-size: 14px;
        color: #000;
      }
    }
  }
  img {
    // width: 200px;
    // height: 260px;
    object-fit: cover;
  }
  .download-btn {
    width: 80px !important;
    border-radius: 20px !important;
  }
  .box {
    width: 100px;
    height: 120px;
  }
}

</style>